import styled from '@emotion/styled/macro';

export const LoginMessage = styled.p`
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.medium};
    margin-bottom: ${props => props.theme.spacing.small};
    text-align: center;

    @media (max-width: 1024px) {
        margin-bottom: ${props => props.theme.spacing.large};
    }
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    width: 100%;
    margin: 0 auto 12px auto;
    justify-content: center;

    @media (max-width: 1024px) {
        flex-direction: column;
        align-items: center;
    }
`;

export const ButtonWrapper = styled.div`
    height: 48px;
    width: 100%;
    max-width: 343px;
    margin: ${props => `${props.theme.spacing.medium} 0`};
`;

export const LoginButtonWrapper = styled(ButtonWrapper)`
    margin-right: 8px;

    @media (max-width: 1024px) {
        margin: 0 0 ${props => `${props.theme.spacing.small}`} 0;
    }
`;

export const RegisterButtonWrapper = styled(ButtonWrapper)`
    margin-left: 8px;

    @media (max-width: 1024px) {
        margin: ${props => `${props.theme.spacing.small}`} 0 0 0;
    }
`;
